(function () {
  'use strict';

  var STAR_COLORS = ['#FFFFFF', '#F7F5F2', '#D8B77B', '#c8b8ff', '#a0e8e4'];

  function StarField(canvas) {
    var ctx = canvas.getContext('2d');
    var stars = [];
    var raf;

    function resize() {
      var p = canvas.parentElement;
      canvas.width = p ? (p.offsetWidth || 800) : 800;
      canvas.height = p ? (p.offsetHeight || 500) : 500;
      build();
    }

    function build() {
      var n = Math.max(80, Math.min(Math.floor(canvas.width * canvas.height / 5000), 220));
      stars = [];
      for (var i = 0; i < n; i++) {
        var r = Math.random() * 1.8 + 0.2;
        stars.push({
          x: Math.random() * canvas.width,
          y: Math.random() * canvas.height,
          r: r,
          a: Math.random(),
          da: (Math.random() * 0.008 + 0.002) * (Math.random() > 0.5 ? 1 : -1),
          c: STAR_COLORS[Math.floor(Math.random() * STAR_COLORS.length)],
          big: r > 1.3
        });
      }
    }

    function draw() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      for (var i = 0; i < stars.length; i++) {
        var s = stars[i];
        s.a += s.da;
        if (s.a <= 0 || s.a >= 1) s.da = -s.da;
        s.a = Math.max(0, Math.min(1, s.a));
        if (s.big) {
          ctx.save();
          ctx.globalAlpha = s.a * 0.3;
          ctx.beginPath();
          ctx.arc(s.x, s.y, s.r * 3.5, 0, Math.PI * 2);
          ctx.fillStyle = s.c;
          ctx.fill();
          ctx.restore();
        }
        ctx.save();
        ctx.globalAlpha = s.a;
        ctx.beginPath();
        ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2);
        ctx.fillStyle = s.c;
        ctx.fill();
        ctx.restore();
      }
      raf = requestAnimationFrame(draw);
    }

    resize();
    draw();
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(resize);
      ro.observe(canvas.parentElement);
    }
    return function () { cancelAnimationFrame(raf); };
  }

  function initHeroStars() {
    var heroWrapper = document.querySelector('.hero-wrapper');
    if (!heroWrapper) return;
    var hero = heroWrapper.querySelector('.hero');
    if (!hero) return;
    hero.classList.add('divinom-hero-main');
    var container = hero.querySelector('.hero__container');
    if (!container) return;
    var mediaGrid = container.querySelector('.hero__media-grid');
    if (!mediaGrid) return;
    var canvas = document.createElement('canvas');
    canvas.className = 'divinom-hero-canvas';
    mediaGrid.appendChild(canvas);
    StarField(canvas);
  }

  function initReveal() {
    var els = document.querySelectorAll('.divinom-reveal');
    if (!els.length) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('visible');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    els.forEach(function (el) { obs.observe(el); });
  }

  function animCount(el, target) {
    var start = performance.now();
    var duration = 1600;
    function step(now) {
      var p = Math.min((now - start) / duration, 1);
      var ease = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.floor(ease * target);
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = target;
    }
    requestAnimationFrame(step);
  }

  function initCounters() {
    var els = document.querySelectorAll('[data-counter]');
    if (!els.length) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          animCount(e.target, parseInt(e.target.getAttribute('data-counter'), 10));
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { obs.observe(el); });
  }

  function initLancementBadge() {
    document.querySelectorAll('p').forEach(function (p) {
      var text = p.textContent.trim();
      if (text.includes('Offre de lancement') && text.includes('✦') && text.length < 40) {
        p.classList.add('divinom-livre-badge-lancement');
      }
    });
  }

  function initReassuranceStyling() {
    document.querySelectorAll('p').forEach(function (p) {
      var text = p.textContent;
      if (text.includes('Paiement') && text.includes('Livraison') && text.includes('auto')) {
        var wrapper = p.parentElement;
        if (wrapper) wrapper.classList.add('divinom-reassurance-wrap');
      }
      if (text.includes('reviendra') && text.includes('fin de l')) {
        var wrapper2 = p.parentElement;
        if (wrapper2) wrapper2.classList.add('divinom-urgency-wrap');
      }
    });
  }

  function initProductTitle() {
    var h1s = document.querySelectorAll('h1');
    for (var i = 0; i < h1s.length; i++) {
      var h1 = h1s[i];
      if (h1.textContent.includes('Divin') && h1.textContent.includes('Om')) {
        var wrapper = h1.parentElement;
        if (wrapper) wrapper.classList.add('divinom-product-title-wrap');
        break;
      }
    }
  }

  function initFixProductLinks() {
    document.querySelectorAll('a[href*="le-livre-divinom-manifestation-de-labondance"]').forEach(function (a) {
      a.href = a.href.replace('le-livre-divinom-manifestation-de-labondance', 'livre');
    });
  }

  function initVideoAutoplay() {
    var vid = document.querySelector('.divinom-video-hero-bg');
    if (!vid) return;
    vid.muted = true;
    vid.defaultMuted = true;
    vid.setAttribute('webkit-playsinline', '');
    var tryPlay = function () {
      var p = vid.play();
      if (p !== undefined) {
        p.catch(function () {});
      }
    };
    if (vid.readyState >= 2) {
      tryPlay();
    } else {
      vid.addEventListener('loadedmetadata', tryPlay, { once: true });
    }
  }

  function init() {
    initHeroStars();
    initReveal();
    initCounters();
    initLancementBadge();
    initReassuranceStyling();
    initProductTitle();
    initFixProductLinks();
    initVideoAutoplay();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
